<div class="content">
<div class="h-100-percent max-width-lg">
    <section class="flex flex-col items-center">
        <img class="mt-80 image"src="/assets/images/unauthorized.png">
        <div class="flex fs-24 fw-600">{{'UNAUTHORIZED.ACCESS' | transloco }}</div>
        <div class="fw-500 fs-16 font-color mt-16"> {{ 'NOTIFICATIONS.AUTHORIZED_ACCESS' | transloco }} </div>
        <div class="fw-500 fs-16 font-color mb-32">Please contact Foundation support. <a class="pb-0" href="https://itsm-servicedesk.temenos.com//plugins/servlet/saml/auth?return_to=%2Fdefault.jsp&isAdmin=false&idp=9b73d10f-7620-4103-a618-5f0d7ea961d6" target="_blank">Click Here</a>.</div>
        <button class="accent mb-32" (click)="logout()">{{'NOTIFICATIONS.LOGOUT' | transloco}}</button>
    </section>
    </div>
</div>